import { Auth0Provider, Auth0ProviderOptions } from "@auth0/auth0-react";
import { Settings } from "luxon";
import { StrictMode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { AnimatedRoutes } from "./router";

function App() {
  const oidcConfig: Auth0ProviderOptions = {
    domain: import.meta.env.VITE_AUTH0_URL,
    clientId: import.meta.env.VITE_AUTH0_CLIENTID,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      scope: "openid profile email offline_access",
    },
    useRefreshTokens: true,
    cacheLocation: "localstorage",
  };

  //#region Default locale for Luxon
  const { i18n } = useTranslation();
  useEffect(() => {
    if (i18n.resolvedLanguage) {
      Settings.defaultLocale = i18n.resolvedLanguage;
    }
  }, [i18n.resolvedLanguage]);
  //#endregion

  return (
    <StrictMode>
      <Auth0Provider {...oidcConfig}>
        <BrowserRouter>
          {/* <QueryParamProvider adapter={ReactRouter6Adapter}> */}
          <AnimatedRoutes isAppInitialized={true} />
          {/* </QueryParamProvider> */}
        </BrowserRouter>

        <Toaster position="top-center" richColors />
      </Auth0Provider>
    </StrictMode>
  );
}

export default App;
